<script lang="ts">
	import StageShapeContainer from './StageShapeContainer.svelte';
	import Headline from './Headline.svelte';
	import SeoHeader from './SeoHeader.svelte';

	export let eventName: string;
	export let imageSrc: string = '';
	export let metaTitle: string;
	export let metaDescription: string;
</script>

<SeoHeader title={metaTitle} description={metaDescription} image={imageSrc} />

<div
	class="cms-article-header h-96 md:h-[31.25rem] mx-auto mb-52 lg:mb-20"
	style="--header-image-src: url('{imageSrc}')"
	{...$$restProps}
>
	<div class="absolute -bottom-52 lg:-bottom-40 w-full">
		<StageShapeContainer class="">
			<Headline class="mt-9" size="hero">{eventName}</Headline>
		</StageShapeContainer>
	</div>
</div>

<div class="flex px-3">
	<div
		class="z-10 w-full md:w-auto mx-auto inline-flex flex-col md:flex-row rounded-3xl justify-center gap-6 px-7.5 py-6 md:px-12"
	></div>
</div>

<style lang="postcss">
	.cms-article-header {
		position: relative;
		width: 100%;
		max-width: 1604px;
		background-image: var(--header-image-src);
		background-size: cover;
		background-position-x: center;
		background-position-y: center;
	}
</style>
